import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  return (
    <Link 
      to="/" 
      className={`flex items-center ${className}`}
      aria-label="PimpMyJob - Retour à l'accueil"
    >
      <div className="relative">
        <div className="absolute text-2xl top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-50">
          💫
        </div>
        <div className="flex items-center relative z-10">
          <img 
            src="/logo.svg" 
            alt="" 
            className="w-10 h-10 mr-3"
            aria-hidden="true"
          />
          <span className="text-xl font-bold gradient-text">PimpMyJob</span>
        </div>
      </div>
    </Link>
  );
};

export default Logo;